import getSeatUpperParent from '%paysera_seat_selection/js/seatSelection/services/getSeatUpperParent';
import compileUniqueSeatParents from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/seat/compileUniqueSeatParents';
import { PURCHASE_STATUS_CHANGE } from '%paysera_seat_selection/js/seatSelection/config/changeSet';

export default ({ Seat }, { payload }) => {
    const { seats, status } = payload;
    const parents = [];
    seats.forEach(({ hash }) => {
        const seat = Seat.get({ hash });
        if (seat) {
            seat.purchaseStatus = status;
            parents.push(getSeatUpperParent(seat));
        }
    });
    compileUniqueSeatParents(parents.filter(Boolean), { seat: [PURCHASE_STATUS_CHANGE] });
};
